import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import Nav from "./Nav";
import {
  List,
  X,
  House,
  Info,
  UsersThree,
  Calendar,
  BookBookmark,
  AddressBook,
  IntersectSquare,
} from "@phosphor-icons/react";
import { scrollToSection } from "../../helper/scrollFunction";

const Navbar = ({ bgColor }) => {
  const [isClicked, setIsClicked] = useState(true);

  function handleClick() {
    setIsClicked((prev) => !prev);
  }
  useEffect(() => {
    if (isClicked) {
      document.body.style.overflow = "auto";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [isClicked]);
  return (
    <>
      <nav
        className={` bg-${bgColor} max-[1069px]:hidden font-popp font-normal  h-[80px] flex justify-center items-center text-[1rem] fixed z-[999999] w-full top-0`}
      >
        <div className="z-1 flex items-center justify-center h-[80px] w-[100%] py-0 px-[24px]">
          <Nav />
        </div>
      </nav>
      <div className="font-popp">
        <button className="max-[1069px]:z-[9999999] hidden max-[1069px]:block max-[1069px]:absolute max-[1069px]:top-6 max-[1069px]:right-6 max-[1069px]:text-[1.8rem] max-[1069px]:cursor-pointer">
          {isClicked ? (
            <List size={32} color="#ffffff" onClick={handleClick} />
          ) : (
            <X size={32} color="#ffffff" onClick={handleClick} />
          )}
        </button>

        <div
          className={
            isClicked
              ? "  max-[1069px]:translate-x-[100%] transition delay-150 duration-300 ease-in-out max-[1069px]:left-[30%] hidden max-[1069px]:gap-0 max-[1069px]:fixed max-[1069px]:top-0 max-[1069px]:z-[9999] max-[1069px]:w-[100%] max-[1069px]:h-[100%] max-[1069px]:bg-[hsl(0,0%,100%,0.1)] max-[1069px]:backdrop-blur max-[1069px]:flex max-[1069px]:flex-col justify-start items-start"
              : "transition delay-150 duration-300 ease-in-out max-[1069px]:translate-x-[0%] max-[1069px]:left-[30%] hidden max-[1069px]:gap-0 max-[1069px]:fixed max-[1069px]:top-0 max-[1069px]:z-[9999] max-[1069px]:w-[100%] max-[1069px]:h-[100%] max-[1069px]:bg-[hsl(0,0%,100%,0.1)] max-[1069px]:backdrop-blur max-[1069px]:flex max-[1069px]:flex-col justify-start items-start"
          }
        >
          <div className="max-[1069px]:text-xl max-[1069px]:mt-40 max-[1069px]:ml-8 max-[1069px]:flex max-[1069px]:flex-col gap-6">
            <div>
              <Link
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="hero"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <House
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1 group"
                />
                Home
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="about"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <Info
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                About
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="teams"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <Info
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                Team
              </Link>
            </div>
            <div>
              <Link
                onClick={handleClick}
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="events"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <Calendar
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                Events
              </Link>
            </div>
            <div>
              <Link
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="resources"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <BookBookmark
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                Resources
              </Link>
            </div>
            <div>
              <Link
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="contact"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <AddressBook
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                Contact
              </Link>
            </div>
            <div>
              <Link
                className="group cursor-pointer text-white shadow-2xl active:text-secondary drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]"
                to="join"
                spy={true}
                smooth={true}
                offset={50}
                duration={500}
              >
                <IntersectSquare
                  size={20}
                  color="#FFFFFF"
                  weight="regular"
                  className="group-active:fill-secondary inline mr-2 mb-1"
                />
                Join Us
              </Link>
            </div>
          </div>
          <div className="w-[70%] mt-auto mb-20 flex flex-col items-center">
            <hr className="h-[1.5px] w-[80%] border-0 bg-secondary" />
            <h1 className="mt-4 text-white font-medium text-[1.50rem]">
              Data Science Club
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
